export default __webpack_public_path__ + "static/media/residency stay highly qualified teaching.314ae8f4.jpg";